import { Routes, Route } from 'react-router-dom';
import { Umsatzplanung } from './pages';
import { Dialog as PlanwerteEditDialog } from './pages/Umsatzplanung/Planung';
import { Dialog as ZieleEditDialog } from './pages/Umsatzplanung/Ziele/Dialog';
import { WithFeatureFlags } from '@/features/featureFlags/WithFeatureFlags';
import { buildLink } from '@/utils';
import { WithLocationGuard } from '@/features/locationGuard/WithLocationGuard';

export function Controlling() {
  return (
    <Routes>
      <Route
        path="/umsatzplanung"
        element={
          <WithLocationGuard
            countries={['DE', 'AT']}
            fallbackURL={buildLink('home')}>
            <WithFeatureFlags name="umsatzplanung">
              <Umsatzplanung />
            </WithFeatureFlags>
          </WithLocationGuard>
        }
      />
      <Route
        path="/umsatzplanung/:year/:month"
        element={
          <WithLocationGuard
            countries={['DE', 'AT']}
            fallbackURL={buildLink('home')}>
            <WithFeatureFlags name="umsatzplanung">
              <Umsatzplanung />
            </WithFeatureFlags>
          </WithLocationGuard>
        }>
        <Route
          path="/umsatzplanung/:year/:month/planwerte/edit"
          element={<PlanwerteEditDialog />}
        />
        <Route
          path="/umsatzplanung/:year/:month/ziele/edit"
          element={<ZieleEditDialog />}
        />
      </Route>
    </Routes>
  );
}
